<template>
<div class="mit-actions-new-person pa-5">
    <BaseMitLoading :show="wizard.loading" :fullscreen="false"/>
    <!-- <v-stepper vertical v-if="!wizard.complete" v-model="wizard.step">
              <v-stepper-header>
                <v-stepper-step :complete="wizard.step > 1" step="1">Choose Create<small>Summarize if needed</small></v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 2" step="2">Basic Information</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 3" step="3">Send Offer Letter</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 4" step="4">Background Check</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 5" step="5">Notify MIT</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 6" step="6">HR Manager Approval</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 7" step="7">Send to Payroll</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step > 8" step="8">Create Inquir</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="wizard.step >9" step="9">Manager Approval</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="10">Review</v-stepper-step>
              </v-stepper-header>
              <v-divider></v-divider>
              <v-stepper-items>
                <v-stepper-content step="1">
                    <v-container>
                      Step 1 <br>
                      *Brand New <br>
                      *Select from request list
                    </v-container>
                  <div class="wizard-actions">
                    <v-btn disabled>Back</v-btn>
                    <v-btn :disabled="false" class="ml-3" color="primary" @click="wizard.step = 2">Next</v-btn>
                  </div>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-container>
                      Step 2
                    </v-container>
                    <div class="wizard-actions">
                      <v-btn @click="wizard.step = 1">Back</v-btn>
                      <v-btn :disabled="false" class="ml-3" color="primary" @click="wizard.step = 3">Next</v-btn>
                    </div>
                </v-stepper-content>
                
              </v-stepper-items>
    </v-stepper>
    <v-card v-if="wizard.complete">
        <div v-if="wizard.loading">
          <v-card-title>Loading...</v-card-title>
          <v-card-text>
              <v-col v-if="wizard.loading" class="d-flex justify-center align-center">
                <v-row>
                  <MitLoading class="pa-10"/>
                </v-row>
              </v-col>
          </v-card-text>
        </div>
        <div v-if="!wizard.loading && wizard.result.success">
          <v-card-title><v-icon class="pr-5" color="success" x-large>mdi-check-circle</v-icon>Success</v-card-title>
          <v-card-text>
              Successfully checked out keys.
          </v-card-text>
        </div>
        <div v-if="!wizard.loading && !wizard.result.success">
          <v-card-title><v-icon color="error" x-large>mdi-alert-circle</v-icon>Error</v-card-title>
          <v-card-text>
          Sorry, an error occurred trying to borrow keys.
          </v-card-text>
          <div class="pb-10"> {{wizard.result.message}}</div>
          <v-btn outlined color="primary" @click="tryAgain()">Try Again</v-btn>
          <v-row align="center" justify="center">
            <v-col cols="12">

            </v-col>
          </v-row>
        </div>
    </v-card> -->
    <v-stepper v-model="wizard.step">
        <v-stepper-header>
            <v-stepper-step :complete="wizard.step > 1" step="1">Create Person</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="wizard.step > 2" step="2">Enter Info</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="wizard.step > 3" step="3">Create offer letter</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4">Completed Step</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
        <v-stepper-content step="1">
            <v-card outlined>
                <v-card-text>
                    <v-card flat>
                        <v-card-text>
                            <p>Choose how to create:</p>
                            <v-radio-group dense v-model="s1.createManually" row>
                                <v-radio label="From Request" :value="false"></v-radio>
                                <v-radio label="Manually Create" :value="true"></v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                            <v-autocomplete
                                color="primary"
                                label="Select Request"
                                v-model="s1.selectedRequest"
                                :items="s1.requests"
                                :filter="s1RequestFilter"
                                :loading="wizard.loading"
                                item-text="person.info.fullName"
                                return-object
                                no-data-text="There are no requests"
                                outlined
                                clearable
                                v-on:change="s1RequestSelectedEvent"
                                >
                                   
                                    <template v-slot:item="data">
                                        <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                        <v-list-item-avatar>
                                            <v-icon>mdi-account</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.person.info.fullName }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.item.description }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>Requested By: {{ data.item.createdBy.fullName }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        </template>
                                    </template>
                            </v-autocomplete>
                            <v-card v-if="s1.selectedRequest" max-width="600" outlined elevation="4">
                                <v-list-item three-line>
                                    <v-list-item-avatar tile size="80" color="grey"><v-icon x-large>mdi-account</v-icon></v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="text-h5 mb-1">{{s1.selectedRequest.person.info.fullName}}</v-list-item-title>
                                        <v-list-item-subtitle>{{s1.selectedRequest.description}}</v-list-item-subtitle>
                                        <v-list-item-subtitle><b>Created By:</b>{{s1.selectedRequest.createdBy.fullName}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-card-text>
                    </v-card>
                    <div class="wizard-actions">
                        <v-btn text disabled>Back</v-btn>
                        <v-btn color="primary" @click="wizardNext">Next</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
            <v-form v-if="person" ref="form" v-model="valid" lazy-validation>
                <v-text-field v-model="person.info.fname" :rules="nameRules" label="First Name" required></v-text-field>
                <v-text-field v-model="person.info.mname" :rules="nameRules" label="Middle Name" required></v-text-field>
                <v-text-field v-model="person.info.lname" :rules="nameRules" label="Last Name" required></v-text-field>
                
                <v-text-field v-model="person.accounts.email" :rules="MitIdRules" label="MIT ID" required></v-text-field>
                <v-text-field v-model="person.accounts.email" :rules="CsailIDRules" label="CSAIL ID" required></v-text-field>
                <v-text-field v-model="person.accounts.email" :rules="emailRules" label="E-mail" required></v-text-field>

                <!-- <v-select v-model="select" :items="items" :rules="[v => !!v || 'Item is required']" label="Item" required></v-select> -->

                <!-- <v-btn :disabled="!valid" color="success" class="mr-4" @click="validate">
                Validate
                </v-btn>

                <v-btn
                color="error"
                class="mr-4"
                @click="reset"
                >
                Reset Form
                </v-btn>

                <v-btn
                color="warning"
                @click="resetValidation"
                >
                Reset Validation
                </v-btn> -->
                </v-form>
                <div class="wizard-actions">
                    <v-btn text @click="wizardBack">Back</v-btn>
                    <v-btn color="primary" @click="wizardNext">Next</v-btn>
                </div>
        </v-stepper-content>

        <v-stepper-content step="3">
            <v-container fluid>
                <v-textarea filled label="Offer Letter" auto-grow :value="offerLetter"></v-textarea>
            </v-container>
            
            <div class="wizard-actions">
                <v-btn text @click="wizardBack">Back</v-btn>
                <v-btn color="primary" @click="wizardNext">Save</v-btn>
            </div>
        </v-stepper-content>

        <v-stepper-content step="4">
            <v-card flat>
              <v-card-title>FINISHED - Step 1</v-card-title>
              <v-card-text>
                <p><b>WAITING</b> for <b>ACCEPTANCE</b> of Offer</p>
                <p>The acceptance letter was sent to the requesting PI or AA for approval and sending. When person is accepts offer continue to next step!</p>
                <a>CONTINUE </a>
              </v-card-text>
            </v-card>
            
            <!-- <div class="wizard-actions">
                <v-btn text @click="wizardBack">Back</v-btn>
                <v-btn disabled color="primary" @click="">Save</v-btn>
            </div> -->
        </v-stepper-content>


        
        </v-stepper-items>
    </v-stepper>
    <!-- <v-stepper v-model="wizard.step" vertical>
        <v-stepper-step :complete="wizard.step > 1" step="1">
            Choose Create 
            <small>Create from a request or create manually</small>
        </v-stepper-step>
        <v-stepper-content step="1">
            <v-card outlined>
                <v-card-text>
                    <v-card flat>
                        <v-card-text>
                            <p>Choose how to create:</p>
                            <v-radio-group dense v-model="s1.createManually" row>
                                <v-radio label="From Request" :value="false"></v-radio>
                                <v-radio label="Manually Create" :value="true"></v-radio>
                            </v-radio-group>
                            <v-divider></v-divider>
                            <v-autocomplete
                                color="primary"
                                label="Select Request"
                                v-model="s1.selectedRequest"
                                :items="s1.requests"
                                :filter="s1RequestFilter"
                                :loading="wizard.loading"
                                item-text="person.info.fullName"
                                return-object
                                no-data-text="There are no requests"
                                outlined
                                clearable
                                v-on:change="s1RequestSelectedEvent"
                                >
                                   
                                    <template v-slot:item="data">
                                        <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                        <v-list-item-avatar>
                                            <v-icon>mdi-account</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.person.info.fullName }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.item.description }}</v-list-item-subtitle>
                                            <v-list-item-subtitle>Requested By: {{ data.item.createdBy.fullName }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        </template>
                                    </template>
                            </v-autocomplete>
                            <v-card v-if="s1.selectedRequest" max-width="600" outlined elevation="4">
                                <v-list-item three-line>
                                    <v-list-item-avatar tile size="80" color="grey"><v-icon x-large>mdi-account</v-icon></v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="text-h5 mb-1">{{s1.selectedRequest.person.info.fullName}}</v-list-item-title>
                                        <v-list-item-subtitle>{{s1.selectedRequest.description}}</v-list-item-subtitle>
                                        <v-list-item-subtitle><b>Created By:</b>{{s1.selectedRequest.createdBy.fullName}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-card-text>
                    </v-card>
                    <div class="wizard-actions">
                        <v-btn text disabled>Back</v-btn>
                        <v-btn color="primary" @click="wizardNext">Next</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-stepper-content>


        <v-stepper-step :complete="wizard.step > 2" step="2">
            Choose Create 
            <small>Create from a request or create manually</small>
        </v-stepper-step>
        <v-stepper-content step="2">
            <v-card color="grey lighten-1" class="mb-12" height="200px">
                
            </v-card>
            <div class="wizard-actions">
                <v-btn text @click="wizardBack">Back</v-btn>
                <v-btn color="primary" @click="wizardNext">Next</v-btn>
            </div>
        </v-stepper-content>

  </v-stepper>-->

  </div> 
</template>

<script>
import moment from 'moment';

import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
import BaseMitUrlParams from '../../../base/components/BaseMitUrlParams.vue';
import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
import BaseMitReservationReadOnly from '../../../base/components/reserve/BaseMitReservationReadOnly.vue';

import BaseMitDateTimeService from '../../services/BaseMitDateTimeService.js';
import MitRequestApprovalService from '../../services/MitRequestApprovalService.js';

export default {
  name: 'MitActionsNewPerson',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    BaseMitUrlParams,
    BaseMitReservationReadOnly
  },
  props: {
  },
  data: function() {
    return {
        baseMitDateTimeService: new BaseMitDateTimeService(),
        wizard:{
          step:1,//default step
          complete:false,
          loading:false,
          result:{
            success:false,
            message:''
          }
        },
        person:null,
        s1:{
            createManually:false,
            requests:[],
            selectedRequest:null,
            requestSearchTerm:''
        },
        nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 200) || 'Name must be less than 200 characters',
        ],
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        MitIdRules: [
            v => !!v || 'MIT ID is required',
            v => /^(?=.*[0-9])/.test(v) || 'MIT ID must be valid',
            v => (v && v.length <= 20) || 'Name must be less than 20 characters',
        ],
        CsailIdRules: [
            v => !!v || 'CSAIL ID is required',
            v => /^(?=.*[a-zA-Z0-9])/.test(v) || 'CSAIL ID must be valid',
            v => (v && v.length <= 200) || 'Name must be less than 200 characters',
        ],
        offerLetter:`<<todaysDate>>
<<Full Name>>
<<Address>>
Dear <<fname>>,
We are extremely pleased to extend an offer of employment to you as a <<jobTitle>> in the Computer Science and Artificial Intelligence Laboratory (CSAIL) at the
Massachusetts Institute of Technology (MIT). This position will begin on <<startDate>>. You
will be under the supervision of <<supervisor>>, who will also be
responsible for conducting your annual performance reviews.
This position offers an annual salary of <<salary>> This position is considered exempt under the
federal and state wage and hour laws, which means you are not eligible for overtime pay beyond your
salary.

Sincerely,
<<HR NAME>>
Human Resources Manager
Computer Science & Artificial Intelligence Laboratory
Massachusetts Institute of Technology`
    }
  },
  created() {
    this.s1GetRequests();

  },
  methods : {
    s1GetRequests(){
        this.wizard.loading = true;
        MitRequestApprovalService.getRequests()
            .then((requests) => {
                //FOR DEMO
                this.s1.requests.push({ header: 'Today ('+this.baseMitDateTimeService.formatGetDate2(this.baseMitDateTimeService.getDateNow())+')' });
                this.s1.requests.push(requests[0]);
                this.s1.requests.push({ divider: true, inset: true });
                this.s1.requests.push({ header: 'Yesterday ('+this.baseMitDateTimeService.formatGetDate2(this.baseMitDateTimeService.getDateNow().subtract(1, "days"))+')' });
                for(let x = 1; x < requests.length; x++){
                    this.s1.requests.push(requests[x]);
                    this.s1.requests.push({ divider: true, inset: true });
                }
                this.wizard.loading = false;
            })
            .catch((error) => {
                this.wizard.loading = false;
                this.wizard.result.message = 'An error occurred trying to get requests.';
                console.log('An error occurred trying to get requests list', error);
            });
    },
    s1RequestFilter (request, queryText, itemText) {
        if(request && request.person){
            const description = request.description.toLowerCase()
            const createdByName = request.createdBy.fullName.toLowerCase();
            const createdById = request.createdBy.csailId.toLowerCase();
            const personName = request.person.info.fullName.toLowerCase();

            const searchText = queryText.toLowerCase()

            return  description.indexOf(searchText) > -1 ||
                    createdByName.indexOf(searchText) > -1 ||
                    createdById.indexOf(searchText) > -1 ||
                    personName.indexOf(searchText) > -1;
        }

        return true;
        
    },
    s1RequestSelectedEvent(request){
        console.log('SELECTED REQUEST', request)
        this.person = request.person;
    },
    wizardNext(){
        this.wizard.step++;
    },
    wizardBack(){
        this.wizard.step--;
    },
    validate () {
        this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    wizardComplete(){
        this.wizard.complete = true;
        this.wizard.loading = true;

        // this.borrowKeys(this.wizard.formData.selectedUser.id, this.wizard.formData.borrowKeys)
        //   .then((data) => {
        //     this.wizard.loading = false;
        //     this.wizard.result.success = true;
        //   })
        //   .catch((error) => {
        //     this.wizard.loading = false;
        //     this.wizard.result.message = 'An error occurred trying to borrow keys.';
        //     console.log('An error occurred trying to get keys list', error);
        //   });
    }
  }
}
</script>

<style lang="scss" scoped>
  .wizard-actions {
      padding-top: 20px;
  }
  .v-stepper__header {
    box-shadow: none;
  }
</style>
